import { render, staticRenderFns } from "./DeleteCredsPopup.vue?vue&type=template&id=06f3dd60&scoped=true"
import script from "./DeleteCredsPopup.vue?vue&type=script&lang=js"
export * from "./DeleteCredsPopup.vue?vue&type=script&lang=js"
import style0 from "./DeleteCredsPopup.vue?vue&type=style&index=0&id=06f3dd60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f3dd60",
  null
  
)

export default component.exports